import React from 'react';
import AdrCodePreview from '../adr-code-preview/adr-code-preview.jsx';
import adrCodeService from '../../services/web/adr-code-service.js';

function AdrCellRenderer({ value }) {
    const codes = value?.adrData ?? [];
    const visible = codes.slice(0, 3);
    const overflow = codes.length - visible.length;

    return (
        <div className="flex items-center gap-1 h-full">
            {visible.map(i => (
                <AdrCodePreview key={i.code} code={adrCodeService.formatAdrCode(i.code)} width={50} showLabel={false} />
            ))}
            {overflow > 0 && (
                <span className="text-xs font-semibold text-gray-500">+{overflow}</span>
            )}
        </div>
    );
}

export default AdrCellRenderer;
